"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecondLevelDomain = exports.COOKIE_THEME_KEY = exports.COOKIE_APP_PREFIX = exports.getCookie = exports.setCookie = void 0;
var setCookie_1 = require("./setCookie");
Object.defineProperty(exports, "setCookie", { enumerable: true, get: function () { return setCookie_1.setCookie; } });
var getCookie_1 = require("./getCookie");
Object.defineProperty(exports, "getCookie", { enumerable: true, get: function () { return getCookie_1.getCookie; } });
var constants_1 = require("./constants");
Object.defineProperty(exports, "COOKIE_APP_PREFIX", { enumerable: true, get: function () { return constants_1.COOKIE_APP_PREFIX; } });
Object.defineProperty(exports, "COOKIE_THEME_KEY", { enumerable: true, get: function () { return constants_1.COOKIE_THEME_KEY; } });
var get_second_level_domain_1 = require("./lib/get-second-level-domain");
Object.defineProperty(exports, "getSecondLevelDomain", { enumerable: true, get: function () { return get_second_level_domain_1.getSecondLevelDomain; } });
